import React from 'react';

import { Drawer } from '../../components';
import FormUpdatePrivateDrivers from '../../components/molecules/configuration/privateDrivers/updateDriver';
import { useStyles } from '../../services/material-ui';

const UpdatePrivateDriver: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormUpdatePrivateDrivers />
      </main>
    </div>
  );
};

export default UpdatePrivateDriver;
